export const claimStatus = {
  O: 'Open'
}

export const directRI = {
  D: 'Direct Reinsurance',
  C: 'Coinsurance',
  R: 'Reinsurance Inwards'
}

export const clmClsTypes = {
  P: 'Provisional Claim',
  N: 'No Claim Case',
  A: 'Actual Claim'
}

export const claimPayCseStat = {
  A: 'NEW',
  B: 'BREACH',
  C: 'CONSENT',
  E: 'ERROR',
  L: 'LITIGATION',
  N: 'NO CLAIM',
  R: 'REPUDIATED',
  S: 'SETTLED',
  T: 'TIME BAR',
  X: 'EX-GRATIA'
}

export const phCltGrps = {
  I: 'Individual',
  C: 'Corporate'
}

export const salutation = {
  MR: 'Mr',
  MRS: 'Mrs',
  MS: 'Ms',
  MDM: 'Mdm',
  DR: 'Dr',
  OTH: 'Others'
}

export const claimantStatus = {
  I: 'Individual',
  E: 'Entity'
}

export const clmtTypeList = {
  F: 'First Party',
  T: 'Third Party'
}

export const prtAckLtrs = {
  I: 'Immediate',
  L: 'Later',
  N: 'No'
}

export const prtClmPV = {
  I: 'Immediate',
  L: 'Later by batch',
  N: 'No'
}

export const mainClass = {
  NULL: 'All Classes',
  CA: 'Cargo',
  FI: 'Fire',
  HU: 'Hull',
  // ME: 'Medical',
  MI: 'Miscellaneous',
  MO: 'Motor'
  // PA: 'Personal Accident'
}
